import React from 'react';
import styles from './SendingImageLoadingBar.module.css';
import LoadingDots from '../utils/LoadingDots';
import { magicIcon } from '../../assets/icons';

interface GeneratingImageLoadingBarProps {
  prompt: string;
}

const GeneratingImageLoadingBar: React.FC<GeneratingImageLoadingBarProps> = ({ prompt }) => {
  // Truncate prompt to first 30 chars + ellipsis if needed
  const truncatedPrompt = prompt.length > 30 
    ? prompt.slice(0, 30) + '...'
    : prompt;

  return (
    <div className={styles.container}>
      <div className={styles.uploadingStamp}>
        <img src={magicIcon} alt="Generating" className={styles.generatingIcon} />
      </div>
      <div className={styles.uploadingStatus}>
        Generating "{truncatedPrompt}"<LoadingDots />
      </div>
    </div>
  );
};

export default GeneratingImageLoadingBar; 